<div class="dynamic-breadcrumb-container" *ngIf="breadcrumbs && breadcrumbs.length > 0">
  <ul class="dynamic-breadcrumb" [ngStyle]="{'background-color': bgColor}">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last" [class.active]="last">
      <a *ngIf="breadcrumb?.url" [routerLink]="breadcrumb?.url" [queryParams]="breadcrumb?.params"
      [ngStyle]="{'color': fontColor, 'font-size': fontSize}">
        {{ breadcrumb.label }}
      </a>
      <span *ngIf="!breadcrumb?.url" [ngStyle]="{'color': lastLinkColor, 'font-size': fontSize}">{{ breadcrumb.label }}</span>
      <span *ngIf="!last" class="separator">{{symbol}}</span>
    </li>
  </ul>
</div>
